<template>
	<div class="echarts-vue"></div>
</template>

<script>
	import debounce from 'lodash.debounce';

	import echarts from 'echarts/index.simple';
	import 'echarts/extension/dataTool'
	import theme from './theme';

	export default {
		props: {
			options: {
				type: Object,
				default: () => ({})
			},
			initOption: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			return {
				chart: null
			};
		},
		mounted() {
			this.$nextTick(() => {
				if (this.$el && echarts) {
					this.init();
				}
			});
		},
		watch: {
			options() {
				if (this.chart) {
					this.chart.setOption(this.options);
				}
			}
		},
		methods: {
			init() {
				if (!this.$el || !echarts) return;
				let chart = this.chart = echarts.init(this.$el, theme, this.initOption);
				if (this.options) {
					chart.setOption(this.options);
				}

				this.resizeHanlder = debounce(() => {
					if (chart && !chart.isDisposed()) {
						chart.resize();
					}
				}, 100, {leading: true});
				window.addEventListener('resize', this.resizeHanlder);
				this.listener = G.addlistener('page_resize', () => {
					if (chart && !chart.isDisposed()) {
						chart.resize();
					}
				});
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resizeHanlder);
			if (this.listener) {
				G.removelistener(this.listener);
			}
			if (this.chart) {
				this.chart.dispose();
				this.chart = null;
			}
		},
		computed: {}
	};
</script>
<style lang="less">
	.echarts-vue {
		height: 360px;
		overflow: hidden;
	}
</style>